import React from 'react'
import FormBuilder from './FormBuilder'

const Form = (props) => {
  return <FormBuilder {...props} />
}

export default Form
